module.exports = __webpack_public_path__ + "media/images/plans/propose_original/proposal-sumple-2-524628be689881d836afa377ab9aeb3b.jpg";